var _Path, _Path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
function SvgIconCameraEnable(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M16 16V8a1 1 0 00-1-1H5a1 1 0 00-1 1v8a1 1 0 001 1h10a1 1 0 001-1z"
  })), _Path2 || (_Path2 = /*#__PURE__*/React.createElement(Path, {
    strokeLinejoin: "round",
    d: "M20 7l-4 3v4l4 3V7z"
  })));
}
export default SvgIconCameraEnable;